import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import JroSnackbar from "./components/JroSnackbar"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();

window.jroAlert = {
    warning: (message) => {
        if (message) {
            let div = document.createElement('div');
            ReactDOM.render(<JroSnackbar severity="warning">{message}</JroSnackbar>, div);
            document.body.appendChild(div);
        }
    },
    info: (message) => {
        if (message) {
            let div = document.createElement('div');
            ReactDOM.render(<JroSnackbar severity="info">{message}</JroSnackbar>, div);
            document.body.appendChild(div);
        }
    },
    error: (message) => {
        if (message) {
            let div = document.createElement('div');
            ReactDOM.render(<JroSnackbar severity="error">{message}</JroSnackbar>, div);
            document.body.appendChild(div);
        }
    },
    success: (message) => {
        if (message) {
            let div = document.createElement('div');
            ReactDOM.render(<JroSnackbar severity="success">{message}</JroSnackbar>, div);
            document.body.appendChild(div);
        }
    },
};